module.exports = __webpack_public_path__ + "img/hh2.aae4e24d.png";